export default class DayOfTheMonthMenuItem {
    // eslint-disable-next-line
    public constructor(public Name: string, public Value: number) {}
}
